module.exports = __webpack_public_path__ + "img/chev-left.1c3d8bd8.svg";